import { useEffect, useState } from 'react';
import '../css/deline/deline.css';
import '../css/deline/all_nft.css';
import { useTranslation } from 'react-i18next'
import { getCookie } from '../App';
import { domain } from './Links/Links';


function Deline() {
    const { t } = useTranslation();

    const [NFTData, setNFTData] = useState([]);

    useEffect(() => {
        document.title = t('Hiket, Deline');

        const xhr = new XMLHttpRequest();
        xhr.open('POST', domain + '/api_all_nft/', true);
        xhr.withCredentials = true;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                setNFTData(data);

                console.log(data)
            }

        }
        xhr.setRequestHeader('Content-Type', 'application/json');
        const CSRFToken = getCookie('csrf_token');
        xhr.setRequestHeader('X-CSRFToken', CSRFToken);
        xhr.send();

    }, [])

    return (
        <div className="main_div">
            <div className='scroll_div'>
                <div className='frist_div'>
                    <div className='all_nft_div'>
                        {NFTData.map((item) => {
                            return (
                                <div className='nft_div' key={item.token}>
                                    <img src={item.image}></img>
                                    <div className='nft_data_div'>
                                        <img src='/icons/solari.png'></img>
                                        <div className='nft_price_div'>{item.price}</div>
                                        <div className='center_div'></div>
                                        <div className='nft_deals_count_div'>
                                            <img src='/icons/deals.png'></img>
                                            <div>{item.deals_count}</div>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Deline